<template>
  <div :class="[$shTemplateStyle.headerItemContainer, $style.container]">
    <div :class="$shTemplateStyle.infoContainer">
      <div :class="$shTemplateStyle.label">{{ $t('players') }}:</div>
      <div :class="$shTemplateStyle.text">
        {{ scopedPlayers.length  || 0}}
        <!-- <span :class="$shTemplateStyle.subText">/{{ allowedPlayers }}</span> -->
      </div>
    </div>
    <div :class="$shTemplateStyle.actionsContainer">
      <div title="View players" :class="$shTemplateStyle.action" @click="viewPlayers">
        <img :src="eyeIcon" alt="View Players" />
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showModal" :class="$utilModalStyle.modalOverlay" @click="showModal = false">
      <div :class="[$utilModalStyle.modalContent]" @click.stop>
        <div :class="$style.modalPlayersList">
          <GroupedPlayersBox
            :players="players"
            :allowedPlayers="allowedPlayers"
            :groupLimit="groupLimit"
            :groups="groups || []"
            :phase="phase"
            :isModeratorView="isModerator"
            :hostId="hostId"
            :pendingModerators="pendingModerators"
          />
        </div>
        <div :class="$utilModalStyle.modalActions">
          <button :class="$utilModalStyle.primaryAction" @click="closeModal">{{ $t('close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EyeIcon from "@/assets/icons/eye.svg";
import styles from "@/css/PlayersCountBox.module.css";
import globalStyles from "@/css/global.module.css";
import utilModalStyles from "@/css/UtilModal.module.css";
import secondaryHeaderTemplateStyles from "@/css/SecondaryHeaderTemplate.module.css";
import GroupedPlayersBox from "./GroupedPlayersBox.vue";

export default {
  components: { GroupedPlayersBox },
  name: "PlayersCountBox",
  props: {
    allowedPlayers: {
      type: Number,
      required: true,
    },
    players: {
      type: Array,
      default: () => [],
    },
    groupLimit: {
      type: Number,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
      default: () => [],
    },
    isModerator: {
      type: Boolean,
      default: false,
    },
    moderatorGroupIds: {
      type: Array,
      default: () => [],
    },
    phase: {
      type: String,
      default: "",
    },
    hostId: {
      type: Number,
      default: null,
    },
    pendingModerators: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      eyeIcon: EyeIcon,
      showModal: false, // Controls modal visibility
      // computedGroups: [],
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $globalStyle() {
      return globalStyles;
    },
    $utilModalStyle() {
      return utilModalStyles;
    },
    $shTemplateStyle() {
      return secondaryHeaderTemplateStyles;
    },
    scopedPlayers() {
      let filtered = this.players;
      // Moderator only sees their groups
      if (this.isModerator) {
        filtered = filtered.filter(
          (p) =>
            this.moderatorGroupIds.includes(Number(p.groupId)) ||
            p.role === "moderator"
        );
      }
      // Exclude ONLY host
      return filtered.filter(
        (p) => p.role !== "host"
      );
    },
  },
  // watch: {
  //   players: { handler: "rebuildGroups", immediate: true, deep: true },
  //   groups: { handler: "rebuildGroups", immediate: true, deep: true },
  // },
  methods: {
    viewPlayers() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    rebuildGroups() {
      const computedGroups = this.groups.map((g) => ({
        id: g.id,
        name: g.name ?? this.$t('group-label', { id: g.id ?? "" }),
        players: [],
      }));

      for (const p of this.players || []) {
        const idx = computedGroups.findIndex((g) => g.id === p.groupId);
        if (idx !== -1) {
          computedGroups[idx].players.push(p);
        }
      }

      this.computedGroups = computedGroups;
    },
  },
  mounted() {},
  beforeUnmount() {},
};
</script>

<style></style>
